"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M13.528 13.623c1.969-.654 3.389-2.504 3.389-4.685 0-2.727-2.22-4.938-4.958-4.938s-4.958 2.211-4.958 4.938c0 2.25 1.511 4.148 3.577 4.744l-.602 2.421h1.653l-.526 4.686 3.831-6.046h-1.653l.247-1.119zm-1.605-2.569c1.154 0 2.09-.932 2.09-2.081s-.936-2.081-2.09-2.081-2.09.932-2.09 2.081.936 2.081 2.09 2.081z';